import { render, staticRenderFns } from "./FoundationTitleList.vue?vue&type=template&id=52863f80"
import script from "./FoundationTitleList.vue?vue&type=script&lang=js"
export * from "./FoundationTitleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports